import React from "react";
import { Box, Flex } from "theme-ui";
import moment from "moment";

interface PaymentSalesSlipInfoProps {
  amount: number;
  approvalDate: string; // YYYYMMDDHHmmss
  approvalNumber: string;
  businessNumber: string;
}

function PaymentSalesSlipInfo({
  amount,
  approvalDate,
  approvalNumber,
  businessNumber,
}: PaymentSalesSlipInfoProps) {
  return (
    <Box
      sx={{
        backgroundColor: "primaryDark",
        borderRadius: "10px",
        color: "#fff",
        margin: "15px 0",
        padding: "15px 20px",
      }}
    >
      <Flex
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
          padding: "5px 0",
        }}
      >
        <Box sx={{ fontSize: "14px" }}>사업자번호</Box>
        <Box sx={{ fontSize: "14px" }}>{businessNumber}</Box>
      </Flex>
      <Flex
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
          padding: "5px 0",
        }}
      >
        <Box sx={{ fontSize: "14px" }}>결제금액</Box>
        <Box sx={{ fontSize: "14px" }}>{Number(amount).toLocaleString()} 원</Box>
      </Flex>
      <Flex
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
          padding: "5px 0",
        }}
      >
        <Box sx={{ fontSize: "14px" }}>거래일시</Box>
        <Box sx={{ fontSize: "14px" }}>
          {approvalDate ? moment(approvalDate, "YYYYMMDDHHmmss").format("YYYY-MM-DD HH:mm:ss") : ''}
        </Box>
      </Flex>
      <Flex
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
          padding: "5px 0",
        }}
      >
        <Box sx={{ fontSize: "14px" }}>승인번호</Box>
        <Box sx={{ fontSize: "14px" }}>{approvalNumber}</Box>
      </Flex>    
    </Box>
  );
}

export default PaymentSalesSlipInfo;
